import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Button, cn } from '@ai-tutor/ui';

/**
 * The wizard's Back and Next (Start session on the last step).
 *
 * Desktop: a ghost Back at the left, the action at the right. A phone: both
 * full height and side by side at the foot of the sheet, Next taking the
 * width, in the thumb's reach; no Back on the first step, where it could
 * only ever be disabled.
 */
export function WizardFooter({
  phone,
  isFirst,
  isLast,
  canStart,
  onBack,
  onNext,
  onStart,
}: {
  phone: boolean;
  isFirst: boolean;
  isLast: boolean;
  canStart: boolean;
  onBack: () => void;
  onNext: () => void;
  onStart: () => void;
}) {
  const action = isLast ? (
    <Button
      onClick={onStart}
      disabled={!canStart}
      className={cn(
        'gap-1 disabled:cursor-not-allowed disabled:opacity-50',
        phone &&
          'h-12 flex-1 disabled:bg-muted disabled:text-muted-foreground disabled:opacity-100'
      )}
    >
      Start session
      <ArrowRight className='h-4 w-4' />
    </Button>
  ) : (
    <Button onClick={onNext} className={cn('gap-1', phone && 'h-12 flex-1')}>
      Next
      <ArrowRight className='h-4 w-4' />
    </Button>
  );

  if (phone) {
    return (
      <footer className='flex flex-shrink-0 gap-2 border-t border-border px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3'>
        {!isFirst && (
          <Button
            variant='outline'
            onClick={onBack}
            className='h-12 gap-1 px-4'
          >
            <ArrowLeft className='h-4 w-4' />
            Back
          </Button>
        )}
        {action}
      </footer>
    );
  }

  return (
    <footer className='flex flex-shrink-0 items-center justify-between gap-2 border-t border-border px-6 py-3'>
      <Button
        variant='ghost'
        onClick={onBack}
        disabled={isFirst}
        className='gap-1'
      >
        <ArrowLeft className='h-4 w-4' />
        Back
      </Button>
      {action}
    </footer>
  );
}
